module.exports = __webpack_public_path__ + "40d3e8f6ed320d04fecf0810dccbb552.png";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_1.png
// module id = ./app/containers/StaticPage/ComeBack/assets/Sec-1/icon_1.png
// module chunks = 40